import React, { useEffect, useState, useCallback } from 'react';
import { Section } from '../layout';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getFillterBlogs, deleteBlog, ClearBlog } from '../../redux/actions/blogs';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { Loader } from '../../components/utils';
import axios from "axios"
import { DataGrid } from '@mui/x-data-grid';
import {
  DeletButtonStyle,
  DeleteonBlur,
  DeleteonFocus,
  DeleteonMouseEnter,
  DeleteonMouseLeave,
  EditButtonStyle,
  EditonBlur,
  EditonFocus,
  EditonMouseEnter,
  EditonMouseLeave,
  ViewButtonStyle,
  ViewonBlur,
  ViewonFocus,
  ViewonMouseEnter,
  ViewonMouseLeave,
  localeTextGrid,
} from "../../constants";
import { ThemeProvider, createTheme } from '@mui/material';
import { useStateContext } from '../../context/ContextProvider';
import { BaseUrl, media } from '../../server';
import { SpinButton, Spiner } from '../utils/Form';
import {truncateTitle} from "../../middleware/truncateTitle"
import { Button } from "@mui/material";
import { CaseFilter, Fillter } from './utils';

import { getFilltercases } from '../../redux/actions/cases';
function DallCase() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentDir } = useStateContext();
  const [isSpinner, setIsSpinner] = useState(false);
  const [caseNumber, setCaseNumber] = useState();
  const [clientName, setClientName] = useState("");
  const [opponentName, setOpponentName] = useState("");

  const [nextSessionDate ,setNextSessionDate]=useState("")
  const [caseType,setCaseType ] = useState("");
  const [courtType, setCourtType] = useState("");
  const [courtName, setCourtName] = useState("");
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const page = paginationModel.page;
  const limit = paginationModel.pageSize;


  useEffect(() => {
   
    dispatch(getFilltercases(page, limit,
      caseNumber,
     clientName,
     opponentName,
     caseType,
     courtType,
     courtName,
     nextSessionDate ));
  }, [page, limit,
    caseNumber,
    clientName,
    opponentName,
    caseType,
    courtType,
    courtName,
    nextSessionDate ,dispatch]);

  const { isLoading, FillterCases, paginationCase } = useSelector((state) => state.Cases);



  const deleteBookHandel = async (id) => {
    setIsSpinner(true);
    try {
     const {data} =  await axios.delete(`${BaseUrl}/case/${id}`,  { withCredentials: true });

      if(data.success){
        toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("case deleted successfully!")}</span>);
        setIsSpinner(false);
        dispatch(getFilltercases(page, limit, 
           caseNumber,
          clientName,
          opponentName,
          caseType,
          courtType,
          courtName,
          nextSessionDate));
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
      setIsSpinner(false);
    }
  };

  const UpdateBookHandeler = (id) => {
  
    navigate(`/EditCase/${id}`);
  };
const ViewCaseHandeler=(id) =>{
  navigate(`/ViewCasePage/${id}`);
}
  const theme = createTheme({
    direction: currentDir
  });

  const totalPages = paginationCase?.totalPages || 0;
  const totalItems = paginationCase?.totalItems || 0; // إضافة هذا إذا كان الخادم يعيد إجمالي العناصر
  const columns = [
    {
      field: "caseNumber",
      headerName: t("case Number"),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{params.value}</p>
          </div>
        )
      }
    },
    {
      field: 'caseType',
      headerName: t("case Type"),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
   

    {
      field: 'clientName',
      headerName:  t("client Name") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{truncateTitle(params.value,3)} </p>
          </div>
        )
      }
    },
    {
      field: 'opponentName',
      headerName:  t("opponant Name") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'courtType',
      headerName:  t("court Type") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'courtName',
      headerName:  t("court Name") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'nextSessionDate',
      headerName:  t("next Session Date") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 180,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'actions',
      headerName: t('Actions') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 225,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (<>
   <div className="flex pt-2 w-[150px] gap-2 items-center ">
   <Button className="rounded-full" 
      style={DeletButtonStyle}
      onMouseEnter={DeleteonMouseEnter}
      onMouseLeave={DeleteonMouseLeave}
      onFocus={DeleteonFocus}
      onBlur={DeleteonBlur}
    onClick={() => deleteBookHandel(params.row._id)}
        >
       {isSpinner ? <Spiner fillColor={"fill-gray-300"} /> :<span className="body-2">{t("Delete")}</span>}  
</Button>
<Button className="rounded-full"
        style={EditButtonStyle}
        onMouseEnter={EditonMouseEnter}
        onMouseLeave={EditonMouseLeave}
        onFocus={EditonFocus}
        onBlur={EditonBlur} 
        onClick={() => UpdateBookHandeler(params.row._id)}
        >
         <span className='body-2'>{t("Edit")}</span> 
</Button>

         <Button className="rounded-full"
        style={ViewButtonStyle}
        onMouseEnter={ViewonMouseEnter}
        onMouseLeave={ViewonMouseLeave}
        onFocus={ViewonFocus}
        onBlur={ViewonBlur} 
        onClick={() => ViewCaseHandeler(params.row._id)}
        >
         <span className='body-2'>{t("View")}</span> 
</Button> 
   </div>
        
         </>
        );
      }
    },
  ];



  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (

        <div className="flex-col  lg:p-16 py-14 px-5 w-full items-center ">
        <h2 className="h2 text-color-1 text-center  dark:text-tcolor-1 mb-4 md:mb-8">{t("All Cases")}</h2>
            <CaseFilter caseNumber={caseNumber} setCaseNumber={setCaseNumber} clientName={clientName} setClientName={setClientName} opponentName={opponentName} setOpponentName={setOpponentName} caseType={caseType} setCaseType={setCaseType} courtType={courtType} setCourtType={setCourtType} courtName={courtName} setCourtName={setCourtName} nextSessionDate={nextSessionDate} setNextSessionDate={setNextSessionDate}/>
            <div className=" items-center  relative justify-center  md:m-10 mt-24 p-2 md:p-10 h-auto bg-white rounded-3xl">
  <ThemeProvider theme={theme}>
    <div style={{ width: '100%', overflowX: 'auto' }}>
                <DataGrid
                  rows={FillterCases}
                  columns={columns}
                  disableRowSelectionOnClick
                  sx={{ minWidth: '1300px' }}     
                  pagination
                  paginationMode="server"
                  rowCount={totalItems} // Total number of items
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[paginationModel.pageSize]}
                  getRowId={(row) => row._id} // Use _id as the unique identifier
                  localeText={localeTextGrid} // تمرير الترجمات
                />
             </div>
  </ThemeProvider>
</div></div>
      )}
    </>
  );
}

export default DallCase;